<template>
    <div>
        <b-row>
            <b-col cols="12" md="2">
                <b-form-group class="mb-0">
                    <label class="d-none d-md-block">&nbsp;</label>
                    <b-button variant="primary" block @click="getReport">
                        {{ $t('get_report').toUpper() }}
                    </b-button>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>
<script>

import StudentProgramService from "@/services/StudentProgramService";

export default {
    methods: {
        getReport() {
            StudentProgramService.lastFourSemesterStatus115RemainingSlotReport()
                .then(res => this._downloadFile(res, this.$t('last_four_semester_status_115_remaining_slot_report') + '.xlsx'))
                .catch(err => this.showErrors(err))
        }
    }
}
</script>
